import React from "react";
import { Container, Row, CardBody, Col } from "reactstrap";
import AccountForm from "./CustomerProfile";
import MetaTagComp from "../../components/common/MetaTagSeo";
import Breadcrumb from "../../components/common/Breadcrumb";
import AdminAccountForm from "./adminProfile";
import { loginUser } from "../../Redux/Slices/userSlice";
import { useStore1Selector } from "index";

const Index = () => {

    const userDet = useStore1Selector(loginUser)

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTagComp meta_tags="Ritike | profile" />
                <Breadcrumb default="Ritike" title="profile" />

                <Container fluid>
                    <Row className="d-flex justify-content-around align-items-center">
                        <CardBody className="px-4">
                            <Row>
                                <Col className="account" md={12}>
                                    {
                                        userDet?.data?.data?.role === "user" ? <AccountForm /> : <AdminAccountForm />
                                    }
                                </Col>
                            </Row>
                        </CardBody>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}


export default Index